import React, { useEffect, useState } from 'react';
import { Bar, Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Link } from 'react-router-dom';
import axios from 'axios'; // Import axios
import AppStrings from '../config/appstring';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { useAuth } from './LogIn/AuthContext';
// Register Chart.js components and plugins
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const selectedDB = localStorage.getItem('selectedDB');
  const Dashboard = ({ user }) => {



    // const { user } = useAuth();
  const [data, setData] = useState(null);  // State to store fetched data
  const [loading, setLoading] = useState(true); // State to manage loading state

  // Fetch data from the backend
  
  useEffect(() => {
      console.log("Logged in as:", user?.name);
      console.log(selectedDB,"dbbbbbbbbbbb")
    // axios
    //   .get(AppStrings.DashboradList+ `?DBNAME=${selectedDB}`)
     axios
      .get(AppStrings.DashboradList)
      .then((response) => {
          // console.log(response,'llllllllllllllllll');
        if (response.data.success === 200) {
         // console.log(response.data.data[0],'llllllllllllllllll');
          setData(response.data.data[0]); 
           // Assuming the data structure from the response
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [user]);



const handleSMSClick = async () => {
    
    axios
      .post(AppStrings.SMSSentLink)
      .then((response) => {
          // console.log(response,'llllllllllllllllll');
        if (response.data.success === 200) {
         
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };



  if (loading) return <div>Loading...</div>;  // Show loading while fetching data

 // console.log(data,'oooooooooooooooooo');

  // Destructure the data from the fetched response
  const { NEWSTUDENT, OLDSTUDENT, TUITION_PAID_DISCOUNT, TUITION_PAID_AMOUNT, OLD_DUE_PENDING, BUS_PAID_DISCOUNT,BUS_PAID_AMOUNT,
    BUS_DUE_PENDING,DUETILLDATE } = data;

//console.log(NEWSTUDENT,'kkkkkkkkkkkkkkkkkkkk');


  // Calculate the balance and other necessary values
  const total = TUITION_PAID_DISCOUNT + TUITION_PAID_AMOUNT + parseFloat(OLD_DUE_PENDING);
  const paid = TUITION_PAID_AMOUNT ;
  const discount = TUITION_PAID_DISCOUNT;
  const balance = total - (paid + discount);

  // Bar chart data
  const chartData = {
    labels: ['Total', 'Paid', 'Discount', 'Balance'],
    datasets: [
      {
        label: 'Amount (₹)',
        data: [total, paid, discount, balance],
        backgroundColor: ['#c5cae9', '#a5d6a7', '#ffe082', '#ef9a9a']
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: 'Financial Overview (Bar Chart)'
      },
      datalabels: {
        anchor: 'end',
        align: 'top',
        color: '#000',
        font: {
          weight: 'bold'
        },
        formatter: (value) => `₹${value.toLocaleString()}`
      }
    }
  };

  // Doughnut chart data (Total context)
  const doughnutData = {
    labels: ['Paid', 'Discount', 'Balance'],
    datasets: [
      {
        label: 'Amount (₹)',
        data: [paid, discount, balance],
        backgroundColor: ['#78f789', '#eaf778', '#f7b478']
      }
    ]
  };

  const doughnutOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom'
      },
      title: {
        display: true,
        text: `Distribution of Total ₹${total.toLocaleString()}`
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const value = tooltipItem.raw;
            const percent = ((value / total) * 100).toFixed(2);
            return `₹${value.toLocaleString()} (${percent}%)`;
          }
        }
      }
    }
  };

  function NumberFormatter({ value }) {
  const formatNumber = (value) => {
    if (value >= 10000000) {
      return (value / 10000000).toFixed(1).replace(/\.0$/, '') + 'C';
    } else if (value >= 100000) {
      return (value / 100000).toFixed(1).replace(/\.0$/, '') + 'L';
    } else if (value >= 1000) {
      return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'T';
    } else {
      return value.toString();
    }
  };

  return <span>{formatNumber(value)}</span>;
}


  return (
    <div className="dashboard" style={{ padding: '0px' }}>
      <div className="row">
        <div className="col-25">
      <h1>
        Dashboard
      </h1>
        </div>
        <div className="col-75">
        <button
    style={styles.iconButton}
   // onClick={() => handleSMSClick()}
  >
    <span style={styles.bellIcon}>
     <span style={styles.bellEmoji}>🔔</span>
    </span>
  </button>
        </div>
      </div>
 <div>
      {/* <h1>Welcome, {user?.name}</h1> */}
    </div>
      <div
        className="card-container"
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '1rem',
          flexWrap: 'wrap',
          marginBottom: '2rem'
        }}
      >
        <Link to="/StudentFeesCollection" style={styles.navLink}>
          <div className="card">
            <h2>Pending</h2>
            <p>₹<NumberFormatter value={(total || 0).toString()}/> </p>
          </div>
        </Link>
        <Link to="/StudentFeesCollection" style={styles.navLink}>
          <div className="card">
            <h2>New Student</h2>
         
             <p>₹<NumberFormatter value={(paid || 0).toString()}/> </p>
          </div>
        </Link>
        <Link to="/StudentFeesCollection" style={styles.navLink}>
          <div className="card">
            <h2>Discount</h2>
           
             <p>₹<NumberFormatter value={(discount || 0).toString()}/> </p>
          </div>
        </Link>
        <Link to="/StudentFeesCollection" style={styles.navLink}>
          <div className="card">
            <h2>As Pay</h2>

             <p>₹<NumberFormatter value={(DUETILLDATE || 0).toString()}/> </p>
          </div>
        </Link>

    
      </div>

      <div className="chart-container" style={{ maxWidth: '700px', margin: '0 auto 2rem' }}>
        <Bar data={chartData} options={chartOptions} />
      </div>

      <div className="chart-container" style={{ maxWidth: '400px', margin: '0 auto' }}>
        <Doughnut data={doughnutData} options={doughnutOptions} />
      </div>
    </div>
  );
}
const styles = {
  navLink: {
    padding: '0px',
    display: 'block',
    textDecoration: 'none',
    color: '#021f29',
    cursor: 'pointer',
    fontSize: '14px',
  },
  iconButton: { 
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: '30px',
  },
 
};


export default Dashboard;
